/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AiModelDto = {
  /**
   * AI 제공자
   */
  provider: AiModelDto.provider;
  /**
   * API 호출 시 사용하는 정확한 모델명
   */
  model: string;
  /**
   * UI에 보여줄 친화 이름
   */
  label: string;
  /**
   * $/1M input tokens
   */
  inputCostPerMillion: number;
  /**
   * $/1M output tokens
   */
  outputCostPerMillion: number;
  /**
   * 기본 모델 여부
   */
  isDefault: boolean;
};
export namespace AiModelDto {
  /**
   * AI 제공자
   */
  export enum provider {
    OPENAI = "openai",
    GEMINI = "gemini",
  }
}
